import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { BotonEditar } from '../Utils/BotonEditar';
import { useAuth } from '../../Auth/AuthContext';

export default function Componentes(){
    const { token } = useAuth();
    const [datos, setDatos] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarcomponente';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar componente', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar componente', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar componente', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('comNombre', '');
        setValue('comActivo', false);
        setMuestraFormulario(false);
    }
    const NuevoComponente = () =>  {
        setValue('id', 0);
        setValue('comNombre', '');
        setValue('comActivo', false);
        setMuestraFormulario(true);
    }

    function handleEdit (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('comNombre', row.comNombre);
        setValue('comActivo', row.comActivo);
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (<BotonEditar Editar={handleEdit} row={row}></BotonEditar>),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Componente', selector: row => row.comNombre, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.comActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];

    const fetchData = async () => {
        let url = '/parametros/listarcomponentes';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };

    useEffect(() => {
        fetchData();
        }, []);

    return (
        <div className ="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Componentes</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/parametros`} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Componente</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario componente</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='comNombre'>Componente</label>
                                                <input id='comNombre' {...register('comNombre', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Componente"/>
                                                {errors.comNombre && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('comActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={NuevoComponente}>Nuevo</button>
                                <DataTable
                                    title="Lista de componentes"
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
        </div>
    );
}